var scope_0 = require('/home/arau/episto/src/aito-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1c46cd5a142953b239fb9c5396ca7388.js').default;
var scope_1 = require('/home/arau/episto/src/aito-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8e3cbe7b6d4a922ccdf834e21d2a4eed.js').default;
var scope_2 = require('/home/arau/episto/src/aito-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_3 = require('/home/arau/episto/src/aito-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ff87224b50288ce107e3ab7213f77fdd.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    